webpackJsonp([942490315352],{

/***/ 1404:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"[Student Project] How to add Sucker Punch to your Rails app in 5 easy steps","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/student-project-how-to-add-sucker-punch-to-your-rails-app-in-5-easy-steps","createdAt":"2014-11-08T07:17:47.100Z","blogAuthor":{"fields":{"name":"Phil Wilt","slug":"blog/author/phil-wilt"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/22sttb9oGgaCgUmCk8yeKi/6344f0991517c23fc35a93dce50855bd/blog-post-blog-student-project-how-to-add-sucker-punch-to-your-rails-app-in-5-easy-steps.png"}}}}}]},"authorJson":{"name":"Phil Wilt","slug":"blog/author/phil-wilt","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/phil-wilt"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-phil-wilt-353b3f953e07756bc27f.js